(function () {
    'use strict';

    angular
        .module('gov.directives')
        .directive('scrollToElem', directive);

    directive.$inject = [];

    /**
     * This allows browser to scroll to the element once it's added to the DOM.
     * If the attribute contains an expression that's evaluated to 'false', the
     * scroll will not happen.
     * e.g.:
     *   <div scroll-to-elem>...</div> // scroll on dom ready
     *   <div scroll-to-elem="false">...</div> // no scrolling
     */
    function directive() {
        return {
            restrict: 'A',
            link: function ($scope, elem, attrs) {
                if (attrs.scrollToElem !== 'false') {
                    $('body').animate({scrollTop: elem.offset().top});
                }
            }
        }
    }
})();